import { CancellationDateFormValues } from '@acorn-portal/shared/src/pages/cancellation/utils/get-initial-cancellation-date-form-values';
import { formatISO } from 'date-fns';

/**
 * Extracts the cancellation date from the form values.
 * Also determines if the time has elapsed since the proposed cancellation date - this is useful for determining redux store values
 * @param values - CancellationDateFormValues
 * @returns string (ISO date tring)
 */
export const getCancellationDateFromValues = (values: CancellationDateFormValues): string => {
	const now = new Date();
	// Process value we'll submit to the API and store in redux
	let cancellationDate = formatISO(now); // NOW
	if (values.cancellationDateDescription === 'LATER') {
		const dateValue = values.cancellationDate ?? '';
		const hourValue = values.cancellationTime?.hours ?? '';
		const minuteValue = values.cancellationTime?.minutes ?? '';
		if (dateValue && hourValue && minuteValue) {
			const dateTimeString = `${dateValue}T${hourValue}:${minuteValue}:00`;
			const formattedDateTime = formatISO(new Date(dateTimeString));
			cancellationDate = formattedDateTime;
		}
	}
	return cancellationDate;
};
